/**
 * The help panel's own words — buttons, headings, hints. What the help *says*
 * lives in src/help/content/, one file per topic.
 */
const help = {
  en: {
    open: "Help",
    title: "Help",
    intro: "Pick a topic to see how it works. Everything here is written for the shop, not for computers.",
    searchPlaceholder: "Search the help…",
    searchLabel: "Search the help",
    noResults: "Nothing found for “{term}”. Try a shorter word.",
    forThisPage: "About this page",
    allTopics: "All topics",
    watchVideo: "Watch a short video",
    backToTopics: "Back to all topics",
    topicsCount: {
      one: "{count} topic",
      other: "{count} topics",
    },
    expand: "Full screen",
    collapse: "Smaller",
    close: "Close help",
    next: "Next topic",
    upNext: "Up next",
    finished: "That was the last topic.",
    topicOf: "Topic {number} of {total}",
    newBadge: "New",
    whatsNewHint: "See what changed in this update",
    imageMissing: "Picture coming soon",
    group: {
      start: "Getting started",
      catalogue: "Catalogue",
      sales: "Selling",
      money: "Money",
      stock: "Stock",
      team: "Your team and shop",
      reference: "Good to know",
    },
  },
  fr: {
    open: "Aide",
    title: "Aide",
    intro: "Choisissez un sujet pour voir comment il fonctionne. Tout est écrit pour la boutique, pas pour les informaticiens.",
    searchPlaceholder: "Rechercher dans l'aide…",
    searchLabel: "Rechercher dans l'aide",
    noResults: "Rien trouvé pour « {term} ». Essayez un mot plus court.",
    forThisPage: "À propos de cette page",
    allTopics: "Tous les sujets",
    watchVideo: "Voir une courte vidéo",
    backToTopics: "Retour à tous les sujets",
    topicsCount: {
      one: "{count} sujet",
      other: "{count} sujets",
    },
    expand: "Plein écran",
    collapse: "Réduire",
    close: "Fermer l'aide",
    next: "Sujet suivant",
    upNext: "À suivre",
    finished: "C'était le dernier sujet.",
    topicOf: "Sujet {number} sur {total}",
    newBadge: "Nouveau",
    whatsNewHint: "Voir ce qui change dans cette mise à jour",
    imageMissing: "Image bientôt disponible",
    group: {
      start: "Pour commencer",
      catalogue: "Catalogue",
      sales: "Vendre",
      money: "Argent",
      stock: "Stock",
      team: "Votre équipe et votre boutique",
      reference: "Bon à savoir",
    },
  },
  ar: {
    open: "المساعدة",
    title: "المساعدة",
    intro: "اختر موضوعاً لتعرف كيف يعمل. كل ما هنا مكتوب لصاحب المحل، لا للمبرمجين.",
    searchPlaceholder: "ابحث في المساعدة…",
    searchLabel: "ابحث في المساعدة",
    noResults: "لا توجد نتائج لـ «{term}». جرّب كلمة أقصر.",
    forThisPage: "حول هذه الصفحة",
    allTopics: "كل المواضيع",
    watchVideo: "شاهد فيديو قصيراً",
    backToTopics: "العودة إلى كل المواضيع",
    topicsCount: {
      zero: "لا مواضيع",
      one: "موضوع واحد",
      two: "موضوعان",
      few: "{count} مواضيع",
      many: "{count} موضوعاً",
      other: "{count} موضوع",
    },
    expand: "ملء الشاشة",
    collapse: "تصغير",
    close: "إغلاق المساعدة",
    next: "الموضوع التالي",
    upNext: "التالي",
    finished: "كان هذا آخر موضوع.",
    topicOf: "الموضوع {number} من {total}",
    newBadge: "جديد",
    whatsNewHint: "اطّلع على ما تغيّر في هذا التحديث",
    imageMissing: "الصورة قريباً",
    group: {
      start: "البداية",
      catalogue: "الكتالوج",
      sales: "البيع",
      money: "المال",
      stock: "المخزون",
      team: "فريقك ومحلّك",
      reference: "من المفيد أن تعرف",
    },
  },
};

export default help;
